import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import "./DettagliFiera.css";

function DettagliFiera() {

    const { id } = useParams();
    const navigate = useNavigate();

    const [fiera, setFiera] = useState(null);
    const [barcodeBuffer, setBarcodeBuffer] = useState("");

    // 🔥 LISTA SCANSIONI PERSISTENTE
    const [scans, setScans] = useState(() => {
        const saved = localStorage.getItem(`scans_fiera_${id}`);
        return saved ? JSON.parse(saved) : [];
    });

    // 🔥 SALVA SCANS IN LOCALSTORAGE
    useEffect(() => {
        localStorage.setItem(`scans_fiera_${id}`, JSON.stringify(scans));
    }, [scans, id]);

    // 🔥 CARICA FIERA
    useEffect(() => {
        const loadFiera = async () => {
            try {
                const response = await axios.get(`/api/fiera/${id}`);
                setFiera(response.data);
            } catch (err) {
                console.error("Errore caricamento fiera:", err);
            }
        };

        loadFiera();
    }, [id]);

    // 🔥 GESTIONE SCANNER
    useEffect(() => {
        const handleKeyPress = (e) => {
            if (fiera?.chiusa) return;

            if (e.key === "Enter") {
                if (barcodeBuffer.trim() !== "") {
                    handleScan(barcodeBuffer.trim());
                    setBarcodeBuffer("");
                }
            } else {
                setBarcodeBuffer(prev => prev + e.key);
            }
        };

        window.addEventListener("keypress", handleKeyPress);
        return () => window.removeEventListener("keypress", handleKeyPress);
    }, [barcodeBuffer, fiera]);

    // 🔥 CHIUSURA FIERA
    const handleChiusuraFiera = async () => {
        if (!window.confirm("Sei sicuro di voler chiudere la fiera?")) return;

        try {
            const response = await axios.post(`/api/fiera/${id}/chiusura`);

            alert("Fiera chiusa correttamente!");
            setFiera(response.data.fieraAggiornata);

        } catch (err) {
            console.error("Errore chiusura fiera:", err);
            alert("Errore durante la chiusura della fiera.");
        }
    };

    // 🔥 SCAN
    const handleScan = async (barcode) => {
        try {
            const response = await axios.post("/api/scan", { barcode });

            if (!response.data.success) {
                alert(response.data.message);
                return;
            }

            const quadro = response.data.quadroAggiornato;

            setScans(prev => [
                { titolo: quadro.titolo, dimensione: quadro.dimensione, barcode },
                ...prev
            ]);

        } catch (err) {
            console.error("Errore scan:", err);
        }
    };

    // 🔥 RIMOZIONE SCAN
    const handleRemoveScan = async (barcode, index) => {
        try {
            const response = await axios.post("/api/scan/remove", { barcode });

            if (!response.data.success) {
                alert(response.data.message);
                return;
            }

            setScans(prev => prev.filter((_, i) => i !== index));

        } catch (err) {
            console.error("Errore rimozione scan:", err);
        }
    };

    return (
        <div id="container">

            {/* Navbar */}
            <div id="nav_bar">
                <div id="title">
                    <p>Fiera: {fiera?.titolo}</p>
                </div>

                <button id="back" onClick={() => navigate("/gestisci")}>
                    Torna indietro
                </button>
            </div>

            {/* Info fiera */}
            {fiera && (
                <div style={{ margin: "20px 0", paddingLeft: "3rem" }}>
                    <p><strong>Luogo:</strong> {fiera.luogo}</p>
                    <p><strong>Data:</strong> {fiera.data}</p>
                </div>
            )}

            {/* Bottone chiusura fiera */}
            <button id="df_close_fiera" onClick={handleChiusuraFiera}>
                Chiusura Fiera
            </button>

            {/* Lista scansioni */}
            <div id="scans_container">
                <h3>Prodotti scannerizzati</h3>

                <div id="scans_scroll">
                    {scans.map((s, index) => (
                        <div className="scan_item" key={index}>
                            <button
                                className="remove_scan_btn"
                                onClick={() => handleRemoveScan(s.barcode, index)}
                            >
                                ×
                            </button>

                            <p><strong>{s.titolo}</strong> — {s.dimensione}</p>
                            <p>Barcode: {s.barcode}</p>
                        </div>
                    ))}
                </div>
            </div>

        </div>
    );
}

export default DettagliFiera;
